import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { StatusPageLayout } from '../components/layout/StatusPageLayout';

const TryAgain: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleTryAgain = () => {
    const cardId = searchParams.get('cardId');
    if (cardId) {
      navigate(`/redirect-to-banxa?cardId=${cardId}`);
    } else {
      console.error('No cardId found in URL params');
    }
  };

  return (
    <StatusPageLayout
      variant="warning"
      title="Payment issue"
      body="We encountered an issue processing your payment. Please try again with the same payment method or choose a different one."
      actions={
        <button type="button" onClick={handleTryAgain} className="ev-btn-primary">
          Try again
        </button>
      }
    />
  );
};

export default TryAgain;
